define.alias("ember-math-helpers/helpers/ceil", "calendar/helpers/ceil");